<div class="camera-watch-container">
  <!-- Header with Add Button -->
  <div class="watch-header">
    <div class="watch-header-left">
      <button 
        class="btn btn-link btn-back" 
        (click)="goHome()"
        title="Go to Home">
        <i class="bi bi-arrow-left"></i>
      </button>
      <h1 class="watch-title">Camera Watch</h1>
    </div>
    <div class="watch-header-buttons">
      <button 
        *ngIf="!isPublicView"
        class="btn btn-primary btn-add-camera" 
        (click)="openAddCameraModal()"
        [disabled]="!canAddMore"
        title="Add cameras">
        <i class="bi bi-plus-lg"></i>
      </button>
    </div>
  </div>

  <!-- Empty State -->
  <div *ngIf="watchItems.length === 0" class="empty-state">
    <i class="bi bi-camera-video empty-state-icon"></i>
    <h2>No Cameras Selected</h2>
    <p *ngIf="!isPublicView">Click the + button above to add cameras to your watch view.</p>
    <p *ngIf="isPublicView">This published camera watch view has no cameras configured.</p>
    <button *ngIf="!isPublicView" class="btn btn-primary btn-lg" (click)="openAddCameraModal()">
      <i class="bi bi-plus-lg"></i> Add Camera
    </button>
  </div>

  <!-- Camera Grid -->
  <div *ngIf="watchItems.length > 0" class="watch-grid" [ngClass]="getGridClass()">
    <app-watch-camera-view
      *ngFor="let item of watchItems"
      [item]="item"
      [refreshTrigger$]="refreshTrigger$"
      [enableRotation]="false"
      [hideRemove]="isPublicView"
      [publishedIdentifier]="publishedIdentifier"
      (remove)="removeItem($event)">
    </app-watch-camera-view>
  </div>

  <!-- Camera Selection Modal -->
  <app-generic-camera-selection-modal
    *ngIf="showModal"
    [existingItems]="watchItems"
    [maxItems]="9"
    (close)="closeModal()"
    (itemsSelected)="onItemsSelected($event)">
  </app-generic-camera-selection-modal>

  <!-- Floating Publish Button -->
  <button 
    *ngIf="canPublish"
    class="btn btn-secondary btn-publish-floating" 
    (click)="openPublishModal()"
    title="Publish camera watch view">
    <i class="bi bi-share"></i> Publish
  </button>

  <!-- Publish Modal -->
  <div class="modal fade" bsModal #publishModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Publish Camera Watch View</h4>
          <button type="button" class="btn-close" (click)="closePublishModal()"></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-12">
              <h5>Active Publications</h5>
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th>Valid Until</th>
                    <th>URL</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let p of publications">
                    <td>{{ p.linkValidToo | date:'short' }}</td>
                    <td>
                      <input 
                        type="text" 
                        class="form-control form-control-sm" 
                        [value]="generatePublishedUrl(p.publishedIdentifier!)" 
                        readonly>
                    </td>
                    <td>
                      <button class="btn btn-outline-danger btn-sm" (click)="deletePublication(p)">
                        <i class="bi bi-trash"></i>
                      </button>
                    </td>
                  </tr>
                  <tr *ngIf="publicationsLoading">
                    <td colspan="3" class="text-center">Loading...</td>
                  </tr>
                  <tr *ngIf="!publicationsLoading && publications.length === 0">
                    <td colspan="3" class="text-center text-muted">No active publications</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-12">
              <h5>Create New Publication</h5>
              <div class="row">
                <div class="col-md-6">
                  <label class="form-label">Valid Until</label>
                  <input 
                    type="datetime-local" 
                    class="form-control" 
                    name="linkValidToo"
                    [(ngModel)]="newPublication.linkValidToo">
                </div>
                <div class="col-md-6 d-flex align-items-end">
                  <button 
                    class="btn btn-primary" 
                    (click)="createPublication()"
                    [disabled]="!newPublication.linkValidToo">
                    <i class="bi bi-plus-lg"></i> Create Publication
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="closePublishModal()">Close</button>
        </div>
      </div>
    </div>
  </div>
</div>
